import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import { useField, useFormikContext, ErrorMessage } from 'formik';
import { Flex, Feedback, Text } from '@hausgold/designsystem';
import { ApiContext, WizardContext } from '../../../utils/contexts.js';
import analyticsTrack from '../../../utils/tracking.js';
import WizardCard from '../../../components/WizardCard.js';
import { getNextStepKey, getNextStepPosition } from '../../../services/models/dialog.js';
import { jsx } from '@emotion/react';
var Choice = function Choice(_ref) {
  var options = _ref.options,
    stepKey = _ref.stepKey,
    lineKey = _ref.lineKey,
    mandatory = _ref.mandatory;
  var _useField = useField(stepKey),
    _useField2 = _slicedToArray(_useField, 3),
    field = _useField2[0],
    meta = _useField2[1],
    helpers = _useField2[2];
  var _useContext = useContext(ApiContext),
    data = _useContext.data;
  var _useContext2 = useContext(WizardContext),
    setCurrentStep = _useContext2.setCurrentStep,
    position = _useContext2.position,
    _useContext2$componen = _useContext2.components,
    CustomWizardCard = _useContext2$componen.CustomWizardCard,
    ChoiceOptionColContainer = _useContext2$componen.ChoiceOptionColContainer,
    ChoiceOptionRowContainer = _useContext2$componen.ChoiceOptionRowContainer,
    dialogId = _useContext2$componen.dialogId,
    leadId = _useContext2$componen.leadId,
    recruiterId = _useContext2$componen.recruiterId;
  var formikContext = useFormikContext();
  var handleOnClick = function handleOnClick(_ref2) {
    var event = _ref2.event,
      value = _ref2.value;
    event.preventDefault();
    helpers.setValue(value);
    var nextStepKey = getNextStepKey(data, lineKey, stepKey);
    var nextStepPosition = getNextStepPosition(data, lineKey, stepKey);

    // If there is no next step key, submit the form.
    if (!nextStepKey) {
      // Track user progress (last Step; Next is "Kontaktformular").
      analyticsTrack({
        event: 'Formwizard Interacted',
        params: {
          dialog_id: dialogId,
          lead_id: leadId,
          recruiter_id: recruiterId,
          label: value,
          step: "".concat(lineKey, "-clickto_step_Kontaktformular")
        }
      });

      /*
       * Note: `As helpers.setValue(value)` is async the `submitForm()` will stop
       * because the value is not set at the moment the field is required but right after.
       * However, a second click on the field will do the trick, and I assume most of
       * the user will simply click again if first click has not the expected impact.
       * Additionally to that, before the change the user had no chance to come to
       * the contact form if `Choice` was the last step at all, as she was redirected
       * to the very beginning instead. So at least it is some improvement.
       * More effort could be done to fix this issue. But this will not be a problem
       * in real world as `Choice` never is the last step and the overall refactoring
       * will fix this as well.
       */
      formikContext.submitForm();
    } else {
      // Track user progress
      analyticsTrack({
        event: 'Formwizard Interacted',
        params: {
          dialog_id: dialogId,
          lead_id: leadId,
          recruiter_id: recruiterId,
          label: value,
          step: "".concat(lineKey, "-clickto_step").concat(nextStepPosition, "_").concat(nextStepKey)
        }
      });
      setCurrentStep(nextStepKey);
    }
  };
  return jsx(Fragment, null, jsx(ChoiceOptionRowContainer, null, options.choices.map(function (choice) {
    return jsx(ChoiceOptionColContainer, {
      key: choice.title,
      position: position,
      context: "choice"
    }, CustomWizardCard ? jsx(CustomWizardCard, {
      isActive: field.value === choice.value,
      iconId: choice === null || choice === void 0 ? void 0 : choice.icon,
      iconSvg: choice === null || choice === void 0 ? void 0 : choice.icon_svg,
      title: choice.title,
      onClick: function onClick(event) {
        return handleOnClick({
          event: event,
          value: choice.value
        });
      }
    }) : jsx(WizardCard, {
      isActive: field.value === choice.value,
      iconId: choice === null || choice === void 0 ? void 0 : choice.icon,
      iconSvg: choice === null || choice === void 0 ? void 0 : choice.icon_svg,
      title: choice.title,
      onClick: function onClick(event) {
        return handleOnClick({
          event: event,
          value: choice.value
        });
      }
    }));
  })), jsx(Flex, {
    mt: 2,
    justifyContent: "space-between"
  }, jsx(ErrorMessage, {
    name: stepKey
  }, function (message) {
    return jsx(Feedback, {
      mb: 0,
      mx: "auto",
      display: "block"
    }, message);
  }), mandatory && !(meta.touched && meta.error) && jsx(Text, {
    as: "div",
    mx: "auto",
    color: "gray.400",
    mb: 0
  }, "* Pflichtfeld")));
};
Choice.propTypes = {
  options: PropTypes.object.isRequired,
  stepKey: PropTypes.string.isRequired,
  lineKey: PropTypes.string.isRequired,
  mandatory: PropTypes.bool
};
Choice.defaultProps = {
  mandatory: false
};
export { Choice as default };